export default {"src":"/_next/static/media/Featured-1.88a1f430.svg","height":56,"width":56};